import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography, styled } from '@mui/material';
import EventContentHistoryItem from './EventContentHistoryItem';
import EventChange from '@classes/GEI/EventChange';
import { ExpandMore } from '@mui/icons-material';

const StyledAccordion = styled(Accordion)`
  .MuiAccordionSummary-content {
    flex-grow: 0 !important;
  }
`

type EventContentHistoryProps = {
  history?: EventChange[];
  onExpandClick: () => void;
  expanded: boolean;
  timezone?: string;
}

const EventContentHistory: React.FC<EventContentHistoryProps> = (props) => {
  const { history, expanded, onExpandClick, timezone } = props;

  if (!history || history.length === 0) return null;

  return (
    <StyledAccordion data-cy="gei-event-content-show-edit-history" disableGutters square elevation={0} expanded={expanded} onClick={onExpandClick}>
      <AccordionSummary expandIcon={<ExpandMore />} >
        <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center">
          <Typography variant="subtitle1">Show edit history</Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails style={{ padding: 0 }}>
        <Box display="grid" gridTemplateRows="min-content" gap="0.5rem" maxHeight="20vh" overflow="auto" width="100%" justifyContent="center" alignItems="center">
          {history?.map((item, index) => (
            <EventContentHistoryItem history={item} key={history.indexOf(item)} index={index} timezone={timezone} />
          ))}
        </Box>
      </AccordionDetails>
    </StyledAccordion>
  )
}

export default EventContentHistory;
